import React from 'react';

import Footer from '../../components/Footer';
import TopNav from '../../components/TopNav';
import EmailCard from './components/EmailCard';
import Hero from './components/Hero';
import NewsletterCard from './components/NewsletterCard';
import NewsroomBand from './components/NewsroomBand';

import pageStyles from '../../styles.module.css';
import styles from './styles.module.css';

// Head metadata and the schema.org graph live in ./seo.ts as plain data and are
// emitted at build time by scripts/prerender.mjs — same arrangement as the
// landing page. See the note at the top of ../RaaSLanding/seo.ts.
const ContactUs: React.FC = () => (
  <div className={pageStyles.page}>
    <TopNav />
    <main>
      <Hero />
      <section className={styles.body}>
        <div className={styles.shell}>
          <div className={styles.grid}>
            <EmailCard />
            <NewsletterCard />
          </div>
        </div>
      </section>
      <NewsroomBand />
    </main>
    <Footer />
  </div>
);

export default ContactUs;
